import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  TEXT_PAGES_ADD_PATH,
  TEXT_PAGES_PATH,
  TEXT_PAGES_UPDATE_PATH,
} from "utils/constants/paths";

const TextPages = Loadable(React.lazy(() => import("./View")));
const TextPagesAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);

export const TextPagesRoute: IRouteItem = {
  path: TEXT_PAGES_PATH,
  iconName: "DocumentText1",
  element: React.createElement(TextPages),
  name: "Text Pages",
  accessKeys: ["SuperAdmin", "Admin", "ContentManager"],
  children: [
    {
      name: "Add / Update",
      path: TEXT_PAGES_ADD_PATH,
      element: React.createElement(TextPagesAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: TEXT_PAGES_UPDATE_PATH,
      element: React.createElement(TextPagesAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
